
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CircuitExtended, RichTextDoc } from '@/api/interfaces';
import { USER_NAMESPACE_PATH } from '@/store/namespaces.type';
import { IS_ADMIN_OR_ROID, IS_ADMIN } from '@/store/getters.type';
import { repositories } from '@/api/ApiFactory';
import ErrorHandler from '@/components/shared/errorHandler';
import ListDocuments from '@/components/shared/ListDocuments.vue';
import DocEditor from '@/components/shared/editor/DocEditor.vue';

const userModule = namespace(USER_NAMESPACE_PATH);

@Component({
  components: {
    ListDocuments,
  },
})
export default class CircuitDocs extends Vue {
  @Prop({ default: null }) private circuitId!: string;
  @Prop({ default: null }) private docSlug!: string | null;
  @userModule.Getter(IS_ADMIN_OR_ROID) private isAdminOrRoid!: boolean;
  @userModule.Getter(IS_ADMIN) private isAdmin!: boolean;

  private loading = {
    documents: true,
    circuit: true,
  };
  private documents: RichTextDoc[] = [];
  private circuit: CircuitExtended | null = null;

  get loadingInitial() {
    return this.loading.documents || this.loading.circuit;
  }

  private async created() {
    await this.fetchCircuit();
    await this.fetchDocuments();
  }

  private canDeleteDoc(doc: RichTextDoc): boolean {
    return this.isAdmin;
  }

  private canCreateDoc(documents: RichTextDoc[]) {
    return this.isAdmin && documents.length < 1;
  }

  private async fetchCircuit() {
    this.loading.circuit = true;
    try {
      const { data } =
        await repositories.connectivity.circuit.getCircuitExtended(this.circuitId);
      this.circuit = data;
    } catch (error: unknown) {
      this.$toasted.error(
        new ErrorHandler(
          { error, status: true },
          { itemMessageText: 'povezavi' },
        ).toString(),
      );
    }
    this.loading.circuit = false;
  }

  private async fetchDocuments() {
    this.loading.documents = true;
    try {
      const response =
        await repositories.documentation.richtextdoc.getRichTextDocs(
          'circuit',
          this.circuitId as string,
        );
      this.documents = response.data.results;
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.documents = false;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    // NOTE: beforeRouteLeave must be on the View itself, not on the nested components
    // check for unsaved changes in the documents

    // We set the default value to empty array, because when there are no
    // existing documents it returns undefined which causes page to crash
    const docs =
      ((this.$refs?.docList as ListDocuments)?.$refs[
        'docEditor'
      ] as DocEditor[]) || [];

    const unsavedDocs = docs
      .filter((docEditor) => docEditor.docHasChanges())
      .map((docEditor) => docEditor.document.name);

    if (unsavedDocs.length === 0) {
      next();
    } else {
      const answer = window.confirm(
        `Spodnji dokumenti imajo neshranjene spremembe:\n${unsavedDocs
          .map((el) => '-  ' + el)
          .join('\n')}\nSte prepričani, da želite zapustiti stran?`,
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
}
